export default "__VITE_ASSET__8d45b0b2__"